import React, { Component } from 'react';

/*Material ui template */
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';


export default class CloseOutWorked extends Component {
  
  static propTypes = {

  };

  state = {
  };

  render() {
    return (
      <React.Fragment>
        <Typography variant="h6" gutterBottom>
          Lesson Learned: What can be improved?
        </Typography>
        <Grid container spacing={24}>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              style={{width: '100%'}}
              multiline
              rows="4"
              margin="normal"
              id="scope_improve"
              name="scope_improve"
              label="Scope"
              fullWidth
              autoComplete="scope_improve"
              value={this.props.closeout.scope_improve}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.scope_improve}
              helperText={this.props.errores.scope_improve}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              style={{width: '100%'}}
              multiline
              rows="4"
              margin="normal"
              id="schedule_improve"
              name="schedule_improve"
              label="Schedule"
              fullWidth
              autoComplete="schedule_improve"
              value={this.props.closeout.schedule_improve}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.schedule_improve}
              helperText={this.props.errores.schedule_improve}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              style={{width: '100%'}}
              multiline
              rows="4"
              margin="normal"
              id="cost_improve"
              name="cost_improve"
              label="Cost"
              fullWidth
              autoComplete="cost_improve"
              value={this.props.closeout.cost_improve}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.cost_improve}
              helperText={this.props.errores.cost_improve}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              style={{width: '100%'}}
              multiline
              rows="4"
              margin="normal"
              id="other_improve"
              name="other_improve"
              label="Other"
              fullWidth
              autoComplete="other_improve"
              value={this.props.closeout.other_improve}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.other_improve}
              helperText={this.props.errores.other_improve}
            />
          </Grid>
        </Grid>
  </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/home/CloseOutImprove.js